module.exports = __webpack_public_path__ + "img/Pic_Services-7.7bc1fd0b.jpg";